import { useTranslation } from 'react-i18next'
import { FaArchive, FaChartBar, FaClock, FaTimesCircle } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import { useState } from 'react'
import PollTab from './tabs/PollTab'
import { TabType } from './tabs/usePollTab'
import type { TabBarProps } from '@/ui-components/components/TabBar'

const usePollPage = () => {
  const { t } = useTranslation()
  // label need to be translation key due TabBar component need this format
  const TABS: TabBarProps['tabs'] = [
    { label: 'poll.recent', value: 'recent', icon: <FaClock /> },
    { label: 'poll.resulted', value: 'result', icon: <FaChartBar /> },
    { label: 'poll.cancelled', value: 'cancelled', icon: <FaTimesCircle /> },
    { label: 'poll.history', value: 'history', icon: <FaArchive /> },
  ]
  const [activeTab, setActiveTab] = useState<TabBarProps['activeTab']>('recent')
  const handleTabChange = (tabValue: TabBarProps['activeTab']) => {
    setActiveTab(tabValue)
  }
  const navigate = useNavigate()
  const onBackAction = () => {
    navigate(-1)
  }
  const renderContent = () => {
    switch (activeTab) {
      case 'recent':
        return <PollTab tabType={TabType.RECENT} />
      case 'result':
        return <PollTab tabType={TabType.RESULTED} />
      case 'cancelled':
        return <PollTab tabType={TabType.CANCELLED} />
      case 'history':
        return <PollTab tabType={TabType.HISTORY} />
    }
  }
  return {
    title: t('poll.pollList'),
    onBackAction,
    renderContent,
    activeTab,
    tabs: TABS,
    handleTabChange,
  }
}

export default usePollPage
